<template lang="pug">
  .paypal
    Spinner(:size="8" :thickness="3")
    PaypalButtons.buttons(
      :style="style"
      :create-order="order"
      :on-init="init"
      :on-click="validate"
      :on-approve="approve"
      :on-error="error"
      :on-cancel="cancel"
    )
</template>

<script>
import uniqid from 'uniqid';
import { get } from '@/helpers';
import { mapActions } from 'vuex';

export default {
  name: 'PayPal',
  props: {
    valid: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    purchase: undefined,
    actions: undefined,
    style: {
      // NOTE: does not work
      // color:  'blue',
      // shape:  'pill',
      // label:  'pay',
      // height: 40
    }
  }),
  watch: {
    valid(value) {
      if (this.actions) {
        if (value === true) this.actions.enable();
        else this.actions.disable();
      }
    }
  },
  methods: {
    init(data, actions) {
      this.actions = actions;
      if (!this.valid) actions.disable();
    },
    validate() {
      this.$emit('validate');
    },
    async order() {
      const errorMessage = {
        id: uniqid(),
        title: 'Fehler',
        text: 'Die Bestellung konnte nicht verarbeitet werden!',
        type: 'error',
        autoclose: 8000
      };

      // get preiously created purchase
      const id = get(this.purchase, 'payment_gateway_response_id');
      return this.submit(id)
        .then(purchase => {
          if (purchase.id) this.purchase = purchase;
          if (purchase.payment_gateway_response_id) return purchase.payment_gateway_response_id;
        })
        .catch(error => {
          this.addMessage(errorMessage);
          this.$emit('error', error);
          throw error;
        });
    },
    approve() {
      const id = get(this.purchase, 'id');
      if (id) this.approvePayment(id);

      this.purchase = undefined;
    },
    error(error) {
      if (this.purchase) {
        const errorMessage = {
          id: uniqid(),
          title: 'Fehler',
          text: 'PayPal meldet ein technisches Problem',
          type: 'error',
          autoclose: 8000
        };
        this.addMessage(errorMessage);

        const id = get(this.purchase, 'id');
        const payment_gateway_response_id = get(this.purchase, 'payment_gateway_response_id');
        if (id && payment_gateway_response_id) this.refusePayment({ id, payment_gateway_response_id });
      }
    },
    cancel(data) {
      const id = get(this.purchase, 'id');
      if (id && data.orderID) this.refusePayment({ id, payment_gateway_response_id: data.orderID });
    },
    leaving() {
      const id = get(this.purchase, 'id');
      const payment_gateway_response_id = get(this.purchase, 'payment_gateway_response_id');
      if (id && payment_gateway_response_id) this.refusePayment({ id, payment_gateway_response_id });
    },
    ...mapActions({
      submit: 'shop/submitCheckoutForm',
      approvePayment: 'shop/approvePayment',
      refusePayment: 'shop/refusePayment',
      addMessage: 'message/add'
    })
  },
  beforeDestroy() {
    this.leaving();
    window.removeEventListener('beforeunload', this.leaving);
  },
  created() {
    window.addEventListener('beforeunload', this.leaving);
  }
};
</script>

<style lang="sass">
.paypal
  // @apply flex flex-col
  position: relative
  min-height: 4rem
  .spinner-container
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 100%
    z-index: 0
  .buttons .paypal-buttons
    @apply bg-gray-100 relative
    min-height: 0 !important
</style>
